export function abbreviateNumber(num: number, showDecimal: boolean = true) {
  if (num >= 1e6) {
    return `${(num / 1e6).toFixed(showDecimal && num < 10e6 ? 1 : 0)}M`
  } else if (num >= 1e3) {
    return `${(num / 1e3).toFixed(showDecimal && num < 10e3 ? 1 : 0)}k`
  }
  return num.toString()
}
